

function dealerProfile() {

    let profileService = [
        {
            name: "Profile",
            icon: "profile",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerProfile",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerProfile",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const profile = () => {
        const profileArr = [
            {
                path: "/index/profile",
                name: "Profile",
                icon: "fee-master",
                logoName: "UserProfile",
                // flag: "isProfileSetting",
            },
        ];

        // if (
        //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
        // ) {
        return profileArr;
        // } else {
        //   return "";
        // }
    };

    let a = dashboard();
    let b = profile();

    profileService[0].items = [...a, ...b];

    return profileService;
}

export default dealerProfile;
